import { UserCenter } from './UserCenter';
import React, { useState } from 'react';
import { isMobileGameDevice } from '../../hooks/useMobileGameViewport';
import { MobileServerSelect } from './MobileServerSelect';

export function ServerSelect({ jwt, onClose, initialTab, servers, startAt }: { jwt: string; servers: number[]; valid: number[]; onClose?: () => void; initialTab?: 'home' | 'topup' | 'mall'; startAt?: 'servers' }) {
  const [mobile] = useState(isMobileGameDevice);
  const [center, setCenter] = useState(startAt !== 'servers' && !!initialTab && initialTab !== 'home');
  if((mobile || startAt === 'servers') && !center) return <MobileServerSelect jwt={jwt} servers={servers} onUserCenter={()=>setCenter(true)} />;
  return <UserCenter jwt={jwt} onClose={onClose} initialTab={initialTab} />;
}
